import { WidgetVersionController } from 'widgets/WidgetVersionManager/WidgetVersionManager.types';

export const VERSION = 1;

export const mapWidgetVersionControllers: WidgetVersionController[] = [];
